import React from "react";

export function Privacy() {
  return (
    <div data-testid="privacy-page" className="max-w-3xl">
      <div className="text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">Juridisch</div>
      <h1 className="heading-display text-4xl sm:text-5xl mt-1 mb-3">Privacyverklaring</h1>
      <p className="text-sm text-slate-500 mb-8">Laatst bijgewerkt: februari 2026</p>

      <div className="gs-card p-6 prose prose-slate max-w-none">
        <h2 className="font-bold text-lg mt-0">1. Wie zijn we?</h2>
        <p>Sprongchecker.nl is een hobby-project gericht op turn-trainers en gymnasten in Nederland. Verantwoordelijke voor verwerking: de eigenaar van sprongchecker.nl, bereikbaar via de <a href="/contact" className="text-orange-600 underline">contactpagina</a>.</p>

        <h2 className="font-bold text-lg mt-6">2. Welke gegevens verwerken we?</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Account:</strong> naam, e-mailadres, versleuteld wachtwoord (bcrypt hash)</li>
          <li><strong>Opgeslagen sprongen:</strong> sprongen die je zelf invoert en bewaart</li>
          <li><strong>Contact:</strong> berichten die je verstuurt via het contactformulier</li>
          <li><strong>Technisch:</strong> sessie-token (JWT) lokaal opgeslagen in je browser</li>
        </ul>

        <h2 className="font-bold text-lg mt-6">3. Waarom?</h2>
        <p>Alleen om de website te laten werken: account aanmaken, inloggen, sprongen opslaan en mailtjes versturen (verificatie, wachtwoord-reset). Geen tracking, geen advertenties, geen doorverkoop aan derden.</p>

        <h2 className="font-bold text-lg mt-6">4. Met wie delen we het?</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Resend</strong> (mailprovider) — om verificatie- en reset-mails te versturen. Resend ziet alleen je e-mailadres + bericht-inhoud.</li>
          <li><strong>Emergent / hosting</strong> — om de website draaiend te houden.</li>
        </ul>
        <p>We delen <strong>nooit</strong> gegevens met derden voor marketing.</p>

        <h2 className="font-bold text-lg mt-6">5. Hoe lang bewaren we het?</h2>
        <p>Zolang je een account hebt. Wil je dat we alles wissen? Stuur een berichtje via de <a href="/contact" className="text-orange-600 underline">contactpagina</a> en we verwijderen je account + opgeslagen sprongen binnen 14 dagen.</p>

        <h2 className="font-bold text-lg mt-6">6. Cookies</h2>
        <p>We gebruiken <strong>geen tracking cookies</strong>. Wel slaan we een login-token op in je browser (localStorage) zodat je ingelogd blijft. Dat is functioneel en valt niet onder de cookie-wet.</p>

        <h2 className="font-bold text-lg mt-6">7. Jouw rechten (AVG)</h2>
        <p>Je hebt het recht op inzage, correctie en verwijdering van je gegevens. Mail het via de contactpagina. Je kunt ook klagen bij de Autoriteit Persoonsgegevens.</p>

        <h2 className="font-bold text-lg mt-6">8. Beveiliging</h2>
        <p>Wachtwoorden worden gehasht met bcrypt en nooit in leesbare vorm opgeslagen. Verbindingen lopen via HTTPS.</p>

        <h2 className="font-bold text-lg mt-6">9. Wijzigingen</h2>
        <p>Bij wijzigingen passen we deze pagina aan en zetten de datum bovenaan bij.</p>
      </div>
    </div>
  );
}

export function Voorwaarden() {
  return (
    <div data-testid="terms-page" className="max-w-3xl">
      <div className="text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">Juridisch</div>
      <h1 className="heading-display text-4xl sm:text-5xl mt-1 mb-3">Algemene Voorwaarden</h1>
      <p className="text-sm text-slate-500 mb-8">Laatst bijgewerkt: februari 2026</p>

      <div className="gs-card p-6 prose prose-slate max-w-none">
        <h2 className="font-bold text-lg mt-0">1. Wat is Sprongchecker?</h2>
        <p>Sprongchecker.nl is een gratis informatieve hulp-tool voor het Nederlandse turnonderdeel groepspringen. De site toont samenvattingen van reglementen, helpt sprongen invoeren en valideren, en biedt sprongformulieren-downloads.</p>

        <h2 className="font-bold text-lg mt-6">2. Geen officiële bron</h2>
        <p><strong>Sprongchecker is GEEN officiële bron.</strong> Alle gegevens zijn handmatig overgetypt en kunnen fouten of verouderde informatie bevatten. Reglementen worden regelmatig aangepast door de bond.</p>
        <p>Raadpleeg ALTIJD de officiële reglementen via <a href="https://dutchgymnastics.nl/trainers-en-coaches/disciplines/groepsspringen/documenten" target="_blank" rel="noreferrer" className="text-orange-600 underline">dutchgymnastics.nl</a> voor de juiste en actuele informatie.</p>

        <h2 className="font-bold text-lg mt-6">3. Aansprakelijkheid</h2>
        <p>Het gebruik van deze website is voor eigen risico. De eigenaar is <strong>niet aansprakelijk</strong> voor:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Foutieve waarden of berekeningen</li>
          <li>Diskwalificaties, puntenaftrek of andere wedstrijdgevolgen</li>
          <li>Uitval, fouten of dataverlies van de website</li>
          <li>Schade door gebruik of onmogelijkheid tot gebruik</li>
        </ul>

        <h2 className="font-bold text-lg mt-6">4. Account & gebruik</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Je bent zelf verantwoordelijk voor het geheim houden van je wachtwoord</li>
          <li>Geen misbruik (spam, hacken, overbelasten, scrapen)</li>
          <li>Geen kwetsende of illegale inhoud via het contactformulier</li>
          <li>De eigenaar mag accounts zonder waarschuwing verwijderen bij misbruik</li>
        </ul>

        <h2 className="font-bold text-lg mt-6">5. Intellectueel eigendom</h2>
        <p>De reglement-PDF's en sprongformulier-templates zijn eigendom van de KNGU. Deze worden alleen aangeboden ter informatie en blijven van de originele rechthebbende. De rest van de website (code, design, samenvattingen) is van de eigenaar.</p>

        <h2 className="font-bold text-lg mt-6">6. Wijzigingen</h2>
        <p>De eigenaar kan de website, content of voorwaarden op elk moment wijzigen of stopzetten zonder voorafgaande aankondiging.</p>

        <h2 className="font-bold text-lg mt-6">7. Toepasselijk recht</h2>
        <p>Op deze voorwaarden is Nederlands recht van toepassing.</p>

        <h2 className="font-bold text-lg mt-6">8. Contact</h2>
        <p>Vragen of problemen? Stuur een bericht via de <a href="/contact" className="text-orange-600 underline">contactpagina</a>.</p>
      </div>
    </div>
  );
}
